const EXPLICIT_EXTENSION_PATTERN = /^(.*?)(?:\s*(?:ext(?:ension)?\.?|poste|x|#)\s*:?\s*(\d+))\s*$/i;
const formatLocalNumber = (digits) => {
    const areaCode = digits.slice(0, 3);
    const exchange = digits.slice(3, 6);
    const subscriber = digits.slice(6, 10);
    return `(${areaCode}) ${exchange}-${subscriber}`;
};
const normalizePhoneNumber = (value) => {
    var _a;
    if (!value)
        return '';
    const trimmedValue = value.trim();
    const extensionMatch = trimmedValue.match(EXPLICIT_EXTENSION_PATTERN);
    const phonePart = (_a = extensionMatch === null || extensionMatch === void 0 ? void 0 : extensionMatch[1]) !== null && _a !== void 0 ? _a : trimmedValue;
    const extension = extensionMatch === null || extensionMatch === void 0 ? void 0 : extensionMatch[2];
    const normalizedPhonePart = phonePart.trimStart();
    if (normalizedPhonePart.startsWith('+') &&
        !normalizedPhonePart.startsWith('+1')) {
        return trimmedValue;
    }
    const digits = phonePart.replace(/\D/g, '');
    const hasNorthAmericanCountryCode = digits.length === 11 && digits.startsWith('1');
    const localDigits = hasNorthAmericanCountryCode ? digits.slice(1) : digits;
    if (localDigits.length !== 10)
        return trimmedValue;
    const formattedPhone = hasNorthAmericanCountryCode
        ? `+1 ${localDigits.slice(0, 3)} ${localDigits.slice(3, 6)}-${localDigits.slice(6)}`
        : formatLocalNumber(localDigits);
    return extension ? `${formattedPhone} ext. ${extension}` : formattedPhone;
};
export default normalizePhoneNumber;
